"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CcExchangeRouter = void 0;
const abis_1 = require("../../abis");
const contract_base_1 = __importDefault(require("../contract-base"));
class CcExchangeRouter extends contract_base_1.default {
    constructor(connectionConfig, contractAddress) {
        super(connectionConfig, contractAddress, abis_1.CCExchangeRouterABI);
    }
    getProtocolPercentageFee() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = this.contract.methods.protocolPercentageFee().call();
            return res;
        });
    }
    thirdPartyFee(thirdPartId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.contract.methods.thirdPartyFee(thirdPartId).call();
        });
    }
    startingBlockNumber() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.contract.methods.startingBlockNumber().call();
            return res.toString();
        });
    }
    isUsed(txId) {
        return __awaiter(this, void 0, void 0, function* () {
            const txIdWith0x = `0x${Buffer.from(txId, "hex").reverse().toString("hex")}`;
            const isUsed = yield this.contract.methods.isRequestUsed(txIdWith0x).call();
            return isUsed;
        });
    }
    wrapAndSwap(lockerScript, parsedTx, merkleProof, blockNumber, blockFee, path) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.contractSendMethodNoError("wrapAndSwap", blockFee ? (+blockFee * 1.3).toFixed() : "100000000000000000", [
                [
                    parsedTx.version,
                    parsedTx.vin,
                    parsedTx.vout,
                    parsedTx.locktime,
                    blockNumber,
                    merkleProof.intermediateNodes,
                    merkleProof.transactionIndex,
                ],
                `0x${lockerScript}`,
                path,
            ]);
        });
    }
}
exports.CcExchangeRouter = CcExchangeRouter;
exports.default = CcExchangeRouter;
//# sourceMappingURL=cc-exchange-router-contract-interface.js.map